/* eslint-disable default-param-last */
/* eslint-disable func-names */
/* eslint-disable import/no-anonymous-default-export */
import * as types from '../types';

const initialState = {
   isLoggedIn: false,
   token: false,
   user: {},
   permissions: [],
   isLoading: false,
   preAuthId: null, // 2FA (novo fluxo)
};

export default function (state = initialState, action) {
   switch (action.type) {
      case types.LOGIN_SUCCESS: {
         const newState = { ...state };
         newState.isLoggedIn = true;
         newState.token = action.payload.token;
         newState.user = action.payload.user;
         newState.permissions = action.payload.permissions || []; // ✅ novo
         newState.isLoading = false;
         newState.preAuthId = null; // novo
         return newState;
      }

      case types.LOGIN_FAILURE: {
         return { ...initialState };
      }

      case types.LOGIN_REQUEST: {
         return { ...state, isLoading: true };
      }

      // ✅ novo: fecha ciclo do logout
      case types.LOGOUT_SUCCESS: {
         return { ...initialState };
      }

      case types.LOGOUT_FAILURE: {
         // se você decidir usar, ao menos derruba loading
         return { ...state, isLoading: false };
      }

      // Mescla imutável — o REGISTER_SUCCESS que existia aqui escrevia direto
      // em `state.user`, mutando o estado anterior.
      case types.AUTH_USER_UPDATED: {
         return {
            ...state,
            user: { ...state.user, ...(action.payload || {}) },
         };
      }

      case types.AUTH_2FA_REQUIRED: {
         return {
            ...state,
            preAuthId: action.payload.preAuthId,
            isLoading: false,
         };
      }

      case types.AUTH_2FA_CLEAR: {
         return {
            ...state,
            preAuthId: null,
         };
      }

      case types.AUTH_2FA_VERIFY_FAILURE: {
         return {
            ...state,
            isLoading: false,
         };
      }

      case types.AUTH_2FA_RESEND_REQUEST: {
         return { ...state, isLoading: true };
      }

      case types.AUTH_2FA_RESEND_FAILURE: {
         return { ...state, isLoading: false };
      }

      default:
         return state;
   }
}
